"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FamilyHistoryDtoToJSON = exports.FamilyHistoryDtoFromJSONTyped = exports.FamilyHistoryDtoFromJSON = exports.instanceOfFamilyHistoryDto = exports.FamilyHistoryDtoBrca2TestResultEnum = exports.FamilyHistoryDtoBrca1TestResultEnum = exports.FamilyHistoryDtoRelationshipEnum = void 0;
var runtime_1 = require("../runtime");
var CancerHistoryDto_1 = require("./CancerHistoryDto");
/**
 * @export
 */
exports.FamilyHistoryDtoRelationshipEnum = {
    Father: 'Father',
    Mother: 'Mother',
    PaternalGrandmother: 'PaternalGrandmother',
    MaternalGrandmother: 'MaternalGrandmother',
    MaternalAunt: 'MaternalAunt',
    PaternalAunt: 'PaternalAunt',
    Sister: 'Sister',
    Brother: 'Brother',
    Daughter: 'Daughter',
    Niece: 'Niece',
    MaternalAuntFemaleCousin: 'MaternalAuntFemaleCousin',
    PaternalAuntFemaleCousin: 'PaternalAuntFemaleCousin',
    MaternalUncleFemaleCousin: 'MaternalUncleFemaleCousin',
    PaternalUncleFemaleCousin: 'PaternalUncleFemaleCousin',
    MaternalHalfSister: 'MaternalHalfSister',
    PaternalHalfSister: 'PaternalHalfSister'
};
/**
 * @export
 */
exports.FamilyHistoryDtoBrca1TestResultEnum = {
    Negative: 'Negative',
    Positive: 'Positive',
    Vus: 'VUS'
};
/**
 * @export
 */
exports.FamilyHistoryDtoBrca2TestResultEnum = {
    Negative: 'Negative',
    Positive: 'Positive',
    Vus: 'VUS'
};
/**
 * Check if a given object implements the FamilyHistoryDto interface.
 */
function instanceOfFamilyHistoryDto(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfFamilyHistoryDto = instanceOfFamilyHistoryDto;
function FamilyHistoryDtoFromJSON(json) {
    return FamilyHistoryDtoFromJSONTyped(json, false);
}
exports.FamilyHistoryDtoFromJSON = FamilyHistoryDtoFromJSON;
function FamilyHistoryDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'relationship': !(0, runtime_1.exists)(json, 'relationship') ? undefined : json['relationship'],
        'brca1TestResult': !(0, runtime_1.exists)(json, 'brca1TestResult') ? undefined : json['brca1TestResult'],
        'brca2TestResult': !(0, runtime_1.exists)(json, 'brca2TestResult') ? undefined : json['brca2TestResult'],
        'familyMemberCancers': !(0, runtime_1.exists)(json, 'familyMemberCancers') ? undefined : (json['familyMemberCancers'].map(CancerHistoryDto_1.CancerHistoryDtoFromJSON)),
        'isBRCA': !(0, runtime_1.exists)(json, 'isBRCA') ? undefined : json['isBRCA'],
        'brca': !(0, runtime_1.exists)(json, 'brca') ? undefined : json['brca'],
    };
}
exports.FamilyHistoryDtoFromJSONTyped = FamilyHistoryDtoFromJSONTyped;
function FamilyHistoryDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'relationship': value.relationship,
        'brca1TestResult': value.brca1TestResult,
        'brca2TestResult': value.brca2TestResult,
        'familyMemberCancers': value.familyMemberCancers === undefined ? undefined : (value.familyMemberCancers.map(CancerHistoryDto_1.CancerHistoryDtoToJSON)),
        'isBRCA': value.isBRCA,
        'brca': value.brca,
    };
}
exports.FamilyHistoryDtoToJSON = FamilyHistoryDtoToJSON;
